import { Component } from '@angular/core';

@Component({
    selector: 'enter-logo',
    template: '',
    styleUrls: ['./logo.component.less'],
})
export class LogoComponent {
}
